<div class="wrapper" [ngClass]="{ hideBackground: noBackground() }">
  <div class="box">
    <icon name="ph:stack" size="42" />
    <h3 class="title">{{ title() | translate }}</h3>
    <p class="subtitle">{{ subtitle() | translate }}</p>
  </div>
</div>
